export const VERSION = '4.2.3';
export const NAME = '@coinbase/wallet-sdk';
//# sourceMappingURL=sdk-info.js.map